<template>
  <div class="d-flex justify-space-around mt-3 mb-3">
    <template v-for="card in cards">
      <v-hover :key="card.id" v-slot:default="{ hover }">
        <v-card
          :raised="hover"
          :to="
            $route.query.pad_email
              ? `${card.route}?pad_email=${$route.query.pad_email}`
              : card.route
          "
          :loading="loading.header"
          :disabled="loading.header"
          active-class="v-card--raised"
          style="flex: 0.19 0.19 20px"
          class="text-center"
        >
          <v-list-item>
            <v-list-item-avatar class="md-ml-0 md-ml-10" :size="85">
              <v-icon x-large :color="card.color">{{ card.avatar }}</v-icon>
            </v-list-item-avatar>
            <v-list-item-content class="ml-n12 mr-n0">
              <v-list-item-title class="headline">{{
                card.quantity
              }}</v-list-item-title>
              <v-list-item-subtitle>{{ card.title }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-hover>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "NavigationBar",

  data: () => ({
    cards: [
      {
        id: "novos",
        title: "Novos",
        avatar: "mdi-account-alert",
        color: "red",
        route: "/novos",
        quantity: 0,
      },
      {
        id: "atrasados",
        title: "Atrasados",
        avatar: "mdi-clock",
        color: "yellow",
        route: "/atrasados",
        quantity: 0,
      },
      {
        id: "andamento",
        title: "Em andamento",
        avatar: "mdi-account-clock",
        color: "orange",
        route: "/andamento",
        quantity: 0,
      },
      {
        id: "concluidos",
        title: "Concluídos",
        avatar: "mdi-account-check",
        color: "green",
        route: "/concluidos",
        quantity: 0,
      },
      {
        id: "total",
        title: "Total",
        avatar: "mdi-account-multiple",
        color: "grey",
        route: "/total",
        quantity: 0,
      },
    ],
  }),

  computed: {
    ...mapState(["total", "loading"]),
  },

  watch: {
    total(value) {
      if (value) {
        for (const card of this.cards) {
          card.quantity = this.total[card.id];
        }
      }
    },
  },

  mounted() {
    this.$store.dispatch("getHeaders");
  },
};
</script>